<template>
  <div class="container-body">
    <div
      v-if="finishedCall"
      class="container-main d-flex align-items-center justify-content-center"
    >
      <div v-if="success">
        <div>
          <div v-if="!isRegistered">
            <p>{{ $t("Employee.ClickToSend") }}</p>
            <button @click="registerDeviceId()" class="custom-button">
              {{ $t("Employee.Send") }}
            </button>
          </div>
          <div v-else>
            <div v-if="isRegistered && employee">
              <div @click="select(employee)">
                <EmployeeCard :employee="employee"></EmployeeCard>
              </div>
              <div>
                <button @click="login()" class="custom-mobile-button">
                  {{ $t("Employee.LoginWithDifferntAccount") }}
                </button>
              </div>
            </div>
            <div v-else>
              <p>{{ $t("Employee.ShowId") }}</p>
              <p>{{ $t("Employee.DeviceId") }}</p>
              <p>{{ deviceId }}</p>
              <button
                @click="refresh()"
                class="custom-mobile-button"
                style="margin-top:20px;"
              >
                <font-awesome-icon icon="retweet" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-body">
      <Version />
    </div>
  </div>
</template>

<script>
import EmployeeMobileDeviceService from "../services/EmployeeMobileDeviceService";
import Version from "../components/Version";
import EmployeeCard from "../components/ui/EmployeeCard";
import LocalStorageService from "../services/LocalStorageService";
import AccountService from "../services/AccountService";
import { getEmployeeLanguage, setMomentLocale } from "../utils";
import moment from "moment";

export default {
  name: "Employee",
  employeeMobileDeviceService: null,
  localStorageService: null,
  accountService: null,
  data() {
    return {
      deviceId: "",
      loader: {},
      success: false,
      finishedCall: false,
      employee: "",
      isRegistered: false,
    };
  },
  components: {
    Version,
    EmployeeCard,
  },
  created() {
    this.employeeMobileDeviceService = new EmployeeMobileDeviceService();
    this.accountService = new AccountService();
    this.localStorageService = new LocalStorageService();
    const token = this.localStorageService.getAuthToken();
    const loggedInEmployee = this.localStorageService.getCurrentEmployee();
    if (token && loggedInEmployee) {
      return this.$router.push({ name: "work-days" });
    }
  },
  mounted() {
    this.deviceId = navigator.userAgent;
    this.getEmployeeMobileDevice();
  },
  methods: {
    getEmployeeMobileDevice() {
      this.loader = this.$loading.show({});
      this.employeeMobileDeviceService
        .getEmployeeMobileDevice(this.deviceId)
        .then((response) => {
          this.finishedCall = true;
          const result = response.data;
          const loggedInEmployee = this.localStorageService.getCurrentEmployee();
          if (result.isRegistered && result.isPublic && !loggedInEmployee) {
            this.$router.push({ name: "employee-login" });
          }
          if (loggedInEmployee) this.employee = loggedInEmployee;
          else this.employee = result.employeeInfo;
          this.isRegistered = result.isRegistered;
          this.success = true;
          this.loader.hide();
        })
        .catch(() => {
          this.finishedCall = true;
          this.success = false;
          this.loader.hide();
        });
    },
    registerDeviceId() {
      this.loader = this.$loading.show({});
      this.employeeMobileDeviceService
        .registerDeviceId(this.deviceId)
        .then(() => {
          this.loader.hide();
          this.getEmployeeMobileDevice();
        })
        .catch(() => {
          this.finishedCall = true;
          this.success = false;
          this.loader.hide();
        });
    },
    select(employee) {
      this.loader = this.$loading.show({});
      this.accountService
        .loginWithDevice(this.employee.id, this.deviceId)
        .then((res) => {
          this.loader.hide();
          const result = res.data;
          this.localStorageService.setAuthToken(result.token);
          this.$root.$emit("onLogin", true);
          this.localStorageService.setCurrentEmployee(result.employee);
          const lang = getEmployeeLanguage(result.employee.language);
          this.$i18n.locale = lang;
          setMomentLocale(lang);
          return this.$router.push({ name: "work-days" });
        })
        .catch(() => {
          this.finishedCall = true;
          this.success = false;
          this.loader.hide();
        });
    },
    login: function() {
      this.$router.push({ name: "employee-login" });
    },
    refresh: function() {
      this.getEmployeeMobileDevice();
    },
  },
};
</script>
